import { Controller, useFormContext } from "react-hook-form";
import React from "react";
import ReactSelect from "react-select";
const Select = (props) => {
    const { control, formState: { errors } } = useFormContext(); // useFormContext to get the methods from parent
    //const [hoveredItem, setHoveredItem] = useState<OptionType | null>(null);
    // const { onHover } = props
    // const Option = (props: OptionProps<OptionType>) => {
    //     return (
    //         <div
    //             {...props.innerProps} // Spreads default props (including hover events)
    //             onMouseOver={() => {
    //                 console.log(props.data)
    //                 onHover?.(props.data.value)
    //             }}
    //             onMouseLeave={() => onHover?.(null)}
    //         >
    //             {props.children}
    //         </div>
    //     );
    // };
    return (React.createElement(Controller, { name: props.name, control: control, render: ({ field }) => {
            const selectedValues = props.options.filter(option => (field.value || []).includes(option.value));
            const modalRoot = document.querySelector("#quoteModal");
            return (React.createElement("div", { onMouseDown: (e) => e.stopPropagation() },
                React.createElement(ReactSelect, { value: selectedValues, options: props.options, isMulti: true, hideSelectedOptions: false, closeMenuOnSelect: false, classNamePrefix: "modal-select", isClearable: false, menuPortalTarget: modalRoot, placeholder: "Select service", menuPosition: "fixed", 
                    //menuIsOpen={true}
                    // styles={{
                    //     menuPortal: base => ({ ...base, zIndex: 9999 })
                    // }}
                    onChange: (items) => {
                        const selected = items ? items.map(item => item.value) : [];
                        field.onChange(selected);
                    } })));
        } }));
};
export default Select;
